import { render, staticRenderFns } from "./UsersConsentComponent.vue?vue&type=template&id=8ca42fb2&scoped=true&"
import script from "./UsersConsentComponent.vue?vue&type=script&lang=js&"
export * from "./UsersConsentComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersConsentComponent.vue?vue&type=style&index=0&id=8ca42fb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca42fb2",
  null
  
)

export default component.exports